<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0">
        {{ $t('ELE0028') }}
      </v-card-title>
      <v-card-text>
        <validation-observer v-slot="{ invalid }">
          <v-row>
            <v-col cols="5">
              <PartCodeInput
                :label="$t('ELE0031')"
                v-model="searchCondition.partCd"
                required
                :disabled="isSearched ? true : isInquiry"
              />
            </v-col>
            <v-col>
              <BtnSearch
                v-if="!isInquiry"
                class="mt-1"
                @click="onClickSearch"
                :disabled="isSearched ? true : invalid"
              />
              <BtnReset v-if="!isInquiry" class="mt-1 mx-4" @click="onClickReset" :disabled="!isSearched" />
            </v-col>
          </v-row>
        </validation-observer>

        <v-row dense v-if="isSearched">
          <v-col>
            <v-card outlined>
              <v-card-title class="pt-1 pb-0">
                {{ $t('ELE0023') }}
                <v-spacer />
                <BtnAdd v-if="!isInquiry" @click="addItem" />
              </v-card-title>
              <v-data-table :headers="headers" :items="items" dense>
                <template v-slot:[`item.action`]="{ item }">
                  <IconInquiry @click="inquiryItem(item)" left />
                  <IconEdit v-if="!isInquiry" @click="editItem(item)" right />
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-container>
    <InspAttachmentDialog
      v-if="item !== null"
      :dialog.sync="dialog"
      :mode="mode"
      :partCd="searchCondition.partCd"
      :inspPointNo="item.inspPointNo"
      :inspTitle.sync="item.inspTitle"
      :inspPoint.sync="item.inspPoint"
      :filePath="item.filePath"
      :versionNo="item.versionNo"
      @change="onClickSearch"
    />
  </v-card>
</template>

<script>
import { API } from '@/plugins/api'
import { ModalMode } from '@/enum'
import { ValidationObserver } from 'vee-validate'

import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import cloneDeep from 'lodash/cloneDeep'

import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import Btn from '@/components/atoms/base/button/Btn'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnAdd from '@/components/atoms/button/BtnAdd'
import BtnReset from '@/components/atoms/button/BtnReset'
import IconEdit from '@/components/atoms/icon/IconEdit'
import IconInquiry from '@/components/atoms/icon/IconInquiry'
import InspAttachmentDialog from '@/components/organisms/master/dialog/InspAttachmentDialog'
import PartCodeInput from '@/components/atoms/select/PartCodeInput'

export default {
  name: 'InspAttachmentForm',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    ValidationObserver,
    TextFieldInput,
    Btn,
    BtnSearch,
    BtnAdd,
    BtnReset,
    IconEdit,
    IconInquiry,
    InspAttachmentDialog,
    PartCodeInput,
  },

  props: {
    partCd: {
      type: String,
      default: '',
    },
    isInquiry: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dialog: false,
      isSearched: false,
      mode: '',
      searchCondition: {
        partCd: '',
      },
      headers: [
        { text: '', align: 'start', divider: true, width: '90', sortable: false, value: 'action' },
        { text: this.$t('ELE0033'), divider: true, value: 'inspTitle' },
        { text: this.$t('ELE0034'), divider: true, value: 'inspPoint' },
        { text: this.$t('ELE0029'), divider: true, value: 'itemUpdatedBy' },
        { text: this.$t('ELE0039'), divider: true, value: 'updaterUserName' },
        { text: this.$t('ELE0030'), value: 'editItemUpdatedAt' },
      ],
      items: [],
      item: null,
      newInspPointNo: 0,
      emptyItem: {
        inspTitle: '',
        inspPoint: '',
        inspectionImage: '',
        filePath: '',
        inspPointNo: 0,
        versionNo: 0,
      },
    }
  },

  methods: {
    addItem() {
      this.mode = ModalMode.ADD
      this.item = cloneDeep(this.emptyItem)
      this.item.inspPointNo = this.newInspPointNo
      this.dialog = true
    },
    editItem(item) {
      this.mode = ModalMode.EDIT
      this.item = cloneDeep(item)
      this.dialog = true
    },
    inquiryItem(item) {
      this.mode = ModalMode.INQUIRY
      this.item = cloneDeep(item)
      this.dialog = true
    },
    async onClickSearch() {
      this.startLoading()
      try {
        const params = {
          partCd: this.searchCondition.partCd,
        }
        this.items = []
        this.newInspPointNo = 0

        const elements = await API.get('/master/partInspPoints', params)
        elements.forEach((element) => {
          element['editItemUpdatedAt'] = this.toLocalTime(element['itemUpdatedAt'])
          element['updaterUserName'] = element['m_user']['userName']
          this.newInspPointNo = element['inspPointNo']
          this.items.push(element)
        })
        this.newInspPointNo += 1
        this.isSearched = true
      } catch (error) {
        this.items = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0034') })))
      } finally {
        this.stopLoading()
      }
    },
    onClickReset() {
      this.isSearched = false
      this.searchCondition.partCd = ''
      this.items = []
    },
  },
  mounted() {
    this.searchCondition.partCd = this.partCd
    if (this.partCd) {
      this.onClickSearch()
    }
  },
}
</script>
